import { Injectable } from '@angular/core';
import { transaction } from '@datorama/akita';
import { NgEntityService, NgEntityServiceConfig } from '@datorama/akita-ng-entity-service';
import { WeatherState, WeatherStore } from './weather.store';

@Injectable({ providedIn: "root" })
@NgEntityServiceConfig({
  resourceName: "weather",
})
export class WeatherService extends NgEntityService<WeatherState>{

  constructor(protected weatherStore: WeatherStore) {
    super(weatherStore);
  }

  @transaction()
  updateState(res: any) {
    if (res) {
      this.store.set(res.results ?? []);
      this.store.setLoading(false);
    }

  }

}
